export default function SvgText() {
    return (
      <>
      <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20px"
      cursor="pointer"
      fill="none"
      viewBox="0 0 24 24"
     >
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 3v18m-3 0h6m4-15V3H5v3"
      ></path>
    </svg>
    </>
  );
}
